
export default {
	'до 20 мин.': 15,
	'20-40 мин.': 35,
	'40 мин. и более': 45,
}



// WEBPACK FOOTER //
// ./src/data/time.js